
import ExampleNavbtns from './ExampleNavbtns';
import ExampleSocial from './ExampleSocial';
import ExampleSearchbar from './ExampleSearchbar';
import ExampleProfile from './ExampleProfile';
import ExampleLogo from "./ExampleLogo";

export default function ExampleNavbar({setPage, theme}) {
    return (
        <div className="exampleNavbar" style={{backgroundColor:`${theme.secondary_color}`}}>
            <div className="exampleNavbar_top">
                <ExampleSocial/>
                <ExampleSearchbar/>
                <ExampleProfile/>
                <ExampleLogo/>
            </div>
            <div style={{height:"10%"}}></div>
            <ExampleNavbtns theme={theme} setPage={setPage}/>
        </div>
    )
}
